import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import AppleIcon from "../../assets/images/apple.png";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../redux";
import { Support, Delivery, Price } from "../../assets/images";

import {
  GiftCardSingleProductApi,
  GiftCardSmartIpgApi,
} from "../../services/api/giftCard";
import { RialSeparator } from "../../utils/price-separator";
import { useHistory } from "react-router-dom";
import CustomInputNumber from "../../components/input-number";

const GiftPayment = () => {
  const [state, setState] = useState({
    loading: false,
    redirect: false,
    to: "",
  });
  const history = useHistory();

  const [singleProduct, setSingleProduct] = useState({
    ProductName: undefined,
    logo: undefined,
    ProductDescription: "",
    Rial: "",
  });
  const [loading, setLoading] = useState(true);
  const { product } = useSelector(({ giftCard }: any) => giftCard);
  const [formValue, setFormValue] = useState<any>({
    mobile_number: undefined,
  });
  const [formErr, setFormErr] = useState<any>({});

  const getSingleProduct = async () => {
    const res = await GiftCardSingleProductApi({
      group_id: product.groupid,
      productCode: product.productCode,
    });

    if (res) {
      setSingleProduct(res);
      setLoading(false);
    }
  };

  useEffect(() => {
    getSingleProduct();
  }, []);

  const productSmartIpgData = {
    additional_data: product.title,
    productCode: product.productCode,
    quantity: 1,
    amount: product.rial,
    productName: product.title,
    mobile: formValue["mobile_number"],
  };

  

    const onSubmit = () => {
      setFormValue({
        ...formValue,
        formValue,
      });
    };

  const validate = (submit: any) => {
    let _errors = {};
    let hasError = false;
    Object.keys(formValue).map((item: any) => {
      // @ts-ignore
      if (!formValue[item]) {
        _errors = { ..._errors, [item]: "این فیلداجباری است" };
        hasError = true;
      } else if (formValue["mobile_number"]?.slice(0, 2) !== "09") {
        _errors = {
          ..._errors,
          ["mobile_number"]: "شماره موبایل باید با 09 شروع شود",
        };
        hasError = true;
      } else if (formValue["mobile_number"]?.length !== 11) {
        _errors = {
          ..._errors,
          ["mobile_number"]: "شماره موبایل باید 11 رقم باشد",
        };
        hasError = true;
      }
    });
    setFormErr(_errors);
    if (!hasError) smartIpg();
  };

  const handleFormValue = ({ target: { name, value } }: any) => {
    setFormValue({
      ...formValue,
      [name]: value,
    });
  };

  const valid = ({ target: { name, value } }: any) => {
    let event = {
      target: {
        name: name,
        value: value,
      },
    };
    switch (name) {
      case "mobile_number":
        if (value.length < 12) {
          handleFormValue(event);
        }
        break;
      default:
        handleFormValue(event);
    }
  };

  const [redirect, setRedirect] = useState(false);
  const base_url = window.location.origin;

  const smartIpg = async () => {
    setLoading(true);

    const res = await GiftCardSmartIpgApi(productSmartIpgData);
    if (res) {
      setLoading(false);
      console.log("link ========> ", res);
      window.open(res.ipg_link, "_self");
    } else {
      setState({ loading: false, redirect: true, to: "/" });
    }
  };

  if (state.redirect) history.push(state.to);

  return (
    <div className="main pt-4 mb-5">
      {/* @ts-ignore */}
      <Grid container justifyContent="center" style={{ marginTop: "45px" }}>
        <Grid item lg={4} md={6} xs={12}>
          {/* @ts-ignore */}
          <Box className="main-container pb-4">
            {loading ? (
              <div style={{ textAlign: "center", padding: "10px" }}>
                {/* @ts-ignore */}
                <Box sx={{ margin: "0px auto" }}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </div>
                  <Typography>در حال دریافت اطلاعات ...</Typography>
                </Box>
              </div>
            ) : (
              <div className="container">
                <Grid container spacing={2} style={{ paddingTop: "20px" }}>
                  <Grid item xs={12} md={7}>
                    {/* @ts-ignore */}
                    <Typography className="giftCardTitle">
                      {singleProduct?.ProductName}
                    </Typography>
                    <Typography
                      style={{
                        color: "#b40100",
                        textAlign: "right",
                        direction: "rtl",
                      }}
                    >
                      {RialSeparator(singleProduct?.Rial)} ریال
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={5}>
                    {/* @ts-ignore */}
                    <img
                      src={singleProduct?.logo}
                      style={{ width: "100%" }}
                      alt="product image"
                    />
                  </Grid>
                </Grid>

                {/* @ts-ignore */}
                <Box
                  style={{
                    borderTop: "1px dotted #d5d5d5",
                    padding: "30px 0px",
                    marginTop: "20px",
                  }}
                >
                  <Grid container spacing={2} style={{ direction: "rtl" }}>
                    <Grid item xs={5}>
                      {/* @ts-ignore */}
                      <Box
                        style={{
                          fontSize: "20px",
                          color: "#b40100",
                          borderRight: "10px solid #b40100",
                          paddingRight: "5px",
                        }}
                      >
                        توضیحات محصول
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      {/* @ts-ignore */}
                      <Box style={{ textAlign: "center" }}>
                        <img src={Support} alt="product image" />
                        <Typography
                          style={{ fontSize: "12px", color: "#003566" }}
                        >
                          پشتیبانی 24 ساعته
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={2}>
                      {/* @ts-ignore */}
                      <Box style={{ textAlign: "center" }}>
                        <img src={Delivery} alt="product image" />
                        <Typography
                          style={{ fontSize: "12px", color: "#003566" }}
                        >
                          تحویل فیزیکی
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={2}>
                      {/* @ts-ignore */}
                      <Box style={{ textAlign: "center" }}>
                        <img src={Price} alt="product image" />
                        <Typography
                          style={{ fontSize: "12px", color: "#003566" }}
                        >
                          بهترین قیمت
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {/* @ts-ignore */}
                <Box
                  style={{
                    direction: "rtl",
                    fontSize: "16px",
                    color: "#636363",
                    marginTop: "25px",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: singleProduct?.ProductDescription,
                  }}
                >
                  {/* {parse(singleProduct?.ProductDescription)} */}
                </Box>
                <Grid item xs={12}>
                  {/* @ts-ignore */}
                  <Box display="flex" alignItems="center">
                    <CustomInputNumber
                      placeholder="09"
                      type={"number"}
                      name="mobile_number"
                      variant="outlined"
                      className="w-100 my-3 input-res"
                      size="small"
                      onChange={valid}
                      autocomplete={"on"}
                      value={formValue["mobile_number"]}
                      dir="rtl"
                    />
                    <Typography
                      className="text-muted text-right small"
                      style={{
                        width: "25%",
                        whiteSpace: "nowrap",
                        marginLeft: "5px",
                        direction: "rtl",
                      }}
                    >
                      شماره موبایل
                    </Typography>
                  </Box>

                  <Typography className="textError">
                    {formErr && formErr["mobile_number"]}
                  </Typography>
                </Grid>

                {/* @ts-ignore */}
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    {/* @ts-ignore */}
                    <Box>
                      <Button
                        variant="contained"
                        className="back endBtn mt-4"
                        onClick={() =>
                          setState({ ...state, redirect: true, to: "/" })
                        }
                      >
                        بازگشت
                      </Button>
                    </Box>
                  </Grid>
                  <Grid item xs={8}>
                    {/* @ts-ignore */}
                    <Box>
                      <Button
                        variant="contained"
                        className="success mt-4"
                        // onClick={() => smartIpg()}
                        onClick={() => validate(onSubmit)}
                      >
                        پرداخت
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default GiftPayment;
